import { SeedingApplyAcceptBodySchema } from '@musinsa/apis-curator';
import { z } from 'zod';

export const ApplyRecruitmentCampaignServiceRequestSchema = z
  .object({
    campaignId: z.number().int(),
    body: SeedingApplyAcceptBodySchema,
  })
  .describe('ApplyRecruitmentCampaignServiceRequest');

export type ApplyRecruitmentCampaignServiceRequest = z.infer<
  typeof ApplyRecruitmentCampaignServiceRequestSchema
>;

export const ApplyRecruitmentCampaignServiceResponseSchema = z
  .object({
    participationId: z.number().int(),
  })
  .describe('ApplyRecruitmentCampaignServiceResponse');

export type ApplyRecruitmentCampaignServiceResponse = z.infer<
  typeof ApplyRecruitmentCampaignServiceResponseSchema
>;
